/**
 * request-opts — shared baseUrl-carrying options for the api-client choke-point
 * functions that require a `Studio*RequestOptions` 2nd argument (packet #3 RC1).
 *
 * MSW intercepts by path in the design/preview env, so the placeholder base is
 * fine here; the real base is injected by the host on deploy (VITE_SETTINGS_API_URL).
 * Screens import the const matching the module they call.
 */
import type {
  StudioLocationsRequestOptions,
  StudioReportsMoneyRequestOptions,
  StudioReportsOverviewRequestOptions,
  StudioSettingsRequestOptions,
} from "@v0y4ge/api-client";

const baseUrl =
  (typeof window !== "undefined" && (window as { __STUDIO_API_BASE__?: string }).__STUDIO_API_BASE__) ||
  (typeof import.meta !== "undefined" &&
    (import.meta as { env?: Record<string, string> }).env?.VITE_SETTINGS_API_URL) ||
  "/api";

export const LOCATIONS_OPTS: StudioLocationsRequestOptions = { baseUrl, surface: "settings" };
/** getCampusPulseReport takes the same shape plus an optional `atWatermark`,
 *  which the report screen supplies per request rather than per surface. */
export const CAMPUS_PULSE_OPTS: { baseUrl: string; surface: string } = { baseUrl, surface: "campus-pulse" };
export const SETTINGS_OPTS: StudioSettingsRequestOptions = { baseUrl, surface: "settings" };
export const REPORTS_MONEY_OPTS: StudioReportsMoneyRequestOptions = { baseUrl, surface: "reports-money" };
export const REPORTS_OVERVIEW_OPTS: StudioReportsOverviewRequestOptions = { baseUrl, surface: "reports-overview" };
